// @vendors
import { useContext, useEffect, useState } from "react";
import { Form, Radio } from "antd";
import Context from "../../../context/appContext";
import {
  fieldsClear,
  getDependencyValue,
  getValueField,
} from "../../../utils/utils";
import moment from "moment";

// @styles
import "./styles.scss";
import CheckboxField from "../checkbox";
import NotifyInfo from "components/notification-info";

export default function RadioButton({ info, key, form, current }) {
  const [radioInfo, setRadioInfo] = useState({});
  const [isAdult, setIsAdult] = useState(true);
  const validate = info.validate ? info.validate : {};
  const {
    dataForm: { data, formResponses, hiddenFields, disabledFields },
    checked,
    isClean,
    setDataForm,
    setIsClean,
    setChecked,
    typePerson,
    setTypePerson,
  } = useContext(Context);

  useEffect(() => {
    const nfo =
      current &&
      current.newItems &&
      (current.newItems.find(
        (field) => field.key === "tipoDePersonaContratante"
      ) ||
        current.newItems.find(
          (field) => field.key === "tipoDePersonaAsegurado"
        ));
    const fechaNacimientoTitular = getValueField(
      "fechaNacimiento",
      formResponses
    );
    const age = moment().diff(
      moment(fechaNacimientoTitular, ["DD/MM/YYYY", "YYYY-MM-DD"]),
      "years"
    );
    setIsAdult(age >= 18);
    setRadioInfo(nfo);
  }, []);

  useEffect(() => {
    radioInfo && radioInfo.values && getDefaultValue();
  }, [radioInfo]);

  useEffect(() => {
    if (
      radioInfo &&
      radioInfo.key === "tipoDePersonaContratante" &&
      hiddenFields[radioInfo.key]
    ) {
      radioInfo.value = "";
      const index = formResponses.findIndex((x) => x.key === radioInfo.key);
      if (index != -1) formResponses[index].value = "";
    }
    radioInfo && radioInfo.values && getDefaultValue();
  }, [hiddenFields[radioInfo.key]]);

  const onChange = (event) => {
    setValue(event);
    const dependencyValue = getDependencyValue(
      current,
      radioInfo.key,
      event.target.value,
      []
    );
    if (dependencyValue && dependencyValue.length > 0) {
      dependencyValue.forEach((item) => {
        const keyLcl = Object.keys(item)[0];
        hiddenFields[keyLcl] = item[keyLcl];
      });
      setDataForm({
        data,
        formResponses,
        hiddenFields: hiddenFields,
        disabledFields,
      });
    }

    //Limpiar rfc de persona Moral o Fisica para evitar problema de que estaba enviando RFC incorrecto al momento de validar
    if (radioInfo.key == "tipoDePersonaContratante") {
      var newFormResponse = [];
      if (radioInfo.value == "personaMoral") {
        newFormResponse = formResponses.filter(
          (x) => x.key != "identificadorPersonaContratante"
        );
        const valueIdentifier = getValueField(
          "identificadorPersonaContratanteMoral",
          formResponses
        );
        if (valueIdentifier) {
          form.setFieldsValue({
            identificadorPersonaContratanteMoral: valueIdentifier,
          });
          form.resetFields(["identificadorPersonaContratante"]);
        }
      } else {
        newFormResponse = formResponses.filter(
          (x) => x.key != "identificadorPersonaContratanteMoral"
        );
        form.resetFields(["identificadorPersonaContratanteMoral"]);
      }
      setDataForm({
        data,
        formResponses: newFormResponse,
        hiddenFields: hiddenFields,
        disabledFields,
      });
    }
  };

  const setValue = (event) => {
    if (
      radioInfo.key == "tipoDePersonaContratante" &&
      radioInfo.value &&
      event.target.value != radioInfo.value &&
      !checked
    ) {
      fieldsClear.forEach((e) => {
        form.setFieldsValue({ [e]: "" });
      });
      disabledFields['fechaDeConstitucionContratante']=false
      setIsClean(false);
      setTypePerson(event.target.value);
    }
    radioInfo.value = event.target.value;
    const index = formResponses.findIndex((x) => x.key === radioInfo.key);
    index != -1
      ? (formResponses[index].value = event.target.value)
      : formResponses.push(radioInfo);
  };

  const getDefaultValue = () => {
    if (
      radioInfo &&
      radioInfo.value &&
      radioInfo.value !== null &&
      radioInfo.value !== ""
    ) {
      form.setFieldsValue({ [radioInfo.key]: radioInfo.value });
      onChange({ target: { value: radioInfo.value } });
      disabledFields['fechaDeConstitucionContratante']=false
    } else {
      const index = formResponses.findIndex((x) => x.key === radioInfo.key);
      let value = index != -1 ? formResponses[index].value : "";
      value = value ? value : radioInfo.defaultValue;
      form.setFieldsValue({ [radioInfo.key]: value });
      onChange({ target: { value: value } });
      disabledFields['fechaDeConstitucionContratante']=false
    }
  };

  return (
    <>
      <div className="contractor-info">
        {radioInfo &&
          radioInfo.key !== "tipoDePersonaAsegurado" &&
          (!isAdult ? (
            <NotifyInfo />
          ) : (
            <CheckboxField
              info={info}
              key={key}
              form={form}
              current={current}
            />
          ))}
        <Form.Item
          className="ant-form-item-normal"
          label={
            radioInfo &&
            radioInfo.key !== "tipoDePersonaAsegurado" &&
            radioInfo.label
          }
          name={radioInfo.key}
          key={key}
          hidden={hiddenFields[radioInfo.key]}
          rules={[
            {
              required:
                hiddenFields[radioInfo.key] ||
                disabledFields[radioInfo.key] ||
                radioInfo.disabled
                  ? false
                  : validate.required,
              message: "Campo obligatorio",
            },
          ]}
        >
          <Radio.Group
            className="radiobutton"
            disabled={false}
            onChange={onChange}
          >
            {radioInfo &&
              radioInfo.values &&
              radioInfo.values.map((item, index) => (
                <Radio
                  className="radiobutton__item"
                  value={item.value}
                  key={`radio-option-${index}`}
                  data-testid={`radio-option-${index}`}
                >
                  <em className="fas fa-braille" />
                  <p>{item.label}</p>
                </Radio>
              ))}
          </Radio.Group>
        </Form.Item>
      </div>
    </>
  );
}
